import { Authority } from '../enums/authority.enum';
import { UserStatus } from '../enums/user-status.enum';
import { UtilHelper } from '../helpers/utils.helper';

export class User {

	id: number;
	name: string;
	username: string; // temp: usado no place
	authority: Authority;
	status: UserStatus;

	constructor(obj: any = { }) {
		Object.assign(this, obj);

		if (!this.username) {
			this.username = "";
		}
		if (this.status != null && this.status['code'] == null) {
			this.status = UtilHelper.getEnumByCod(this.status, UserStatus);
		}
		if (this.authority != null && this.authority['code'] == null) {
			this.authority = UtilHelper.getEnumByCod(this.authority, Authority);
		}
	}

	toJson(updateOnlyName: boolean): any {
		if (updateOnlyName) {
			return {
				id: this.id,
				name: this.name
			};
		} else {
			return {
				id: this.id,
				name: this.name,
				username: this.username,
				authority: this.authority['code']
			};
		}
	}

	toUserPlaceJson(updateOnlyName: boolean): any {
		if (updateOnlyName) {
			return {
				user: {
					id: this.id,
					name: this.name
				}
			};
		} else {
			return {
				user: {
					id: this.id,
					name: this.name,
					username: this.username,
					authority: this.authority['code']
				}
			};
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/models/user.model.ts